'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.fetchNodeJs = fetchNodeJs;
exports.fetchBrowser = fetchBrowser;

var _utils = require('./utils');

var utils = _interopRequireWildcard(_utils);

var _zlib = require('zlib');

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _fetchJsonp = require('fetch-jsonp');

var _fetchJsonp2 = _interopRequireDefault(_fetchJsonp);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

var gunzipAsync = (0, _bluebird.promisify)(_zlib.gunzip);

function fetchNodeJs(uri) {
  var options = {
    responseType: 'arraybuffer'
  };
  return _bluebird2.default.resolve().then(function () {
    return _axios2.default.get(uri, options);
  }).then(function (response) {
    return response.data;
  }).then(function (data) {
    return gunzipAsync(data);
  }).then(function (buffer) {
    return JSON.parse(buffer.toString());
  });
}
function fetchBrowser(uri) {
  return _bluebird2.default.resolve().then(function () {
    return (0, _fetchJsonp2.default)(uri);
  }).then(function (response) {
    return response.json();
  });
}

exports.default = function () {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var uri = void 0;
  var promise = void 0;
  try {
    if (typeof window === 'undefined') {
      uri = utils.createUri(params, opts);
      promise = fetchNodeJs(uri);
    } else {
      uri = utils.createUri(params, _extends({}, opts, { jsonp: true }));
      promise = fetchBrowser(uri);
    }
  } catch (error) {
    return _bluebird2.default.reject(error);
  }

  return promise.then(function (json) {
    if (json[0].allcount !== undefined) {
      var _json = _toArray(json),
          result = _json[0],
          items = _json.slice(1);

      utils.normalizeNovelType(items);

      return { uri: uri, allcount: result.allcount, items: items };
    }

    return { uri: uri, items: json };
  });
};


// WEBPACK FOOTER //
// ./src/fetch.js